import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const DialogForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MutedLine = styled.div`
  font-size: 12px;
  color: ${colors.textSecondary};
`;

